import { Link, useParams } from "react-router-dom";
import General from "./tabs/General";
import Notifications from "./tabs/Notifications";
import clsx from "clsx";
import FirehoseConfig from "./tabs/FirehoseConfig";
import SquawkConfig from "./tabs/SquawkConfig";
import Billing from "./tabs/Billing";
import Troubleshooting from "./tabs/Troubleshooting";

const settingsNavigation = [
  { name: "General", href: "general" },
  { name: "Notifications", href: "notifications" },
  { name: "Firehose Config", href: "firehose" },
  { name: "Squawk Player Config", href: "squawk-player" },
  { name: "Billing", href: "billing" },
  { name: "Troubleshooting", href: "troubleshooting" },
];

const tabs = {
  general: <General />,
  notifications: <Notifications />,
  firehose: <FirehoseConfig />,
  "squawk-player": <SquawkConfig />,
  billing: <Billing />,
  troubleshooting: <Troubleshooting />,
};

export default function SettingsPage() {
  const tab = useParams()?.tab || "general";

  const renderTab = tabs[tab as keyof typeof tabs] || null;

  return (
    <>
      <div>
        <div className="">
          <main>
            <h1 className="sr-only">Account Settings</h1>

            <header className="border-b border-gray-200 dark:border-white/5 sticky top-0 backdrop-blur-md bg-white/80 dark:bg-transparent transition-colors">
              {/* Secondary navigation */}
              <nav className="flex overflow-x-auto py-4">
                <ul
                  role="list"
                  className="flex min-w-full flex-none gap-x-6 px-4 text-sm/6 font-semibold text-gray-500 dark:text-gray-400 sm:px-6 lg:px-8"
                >
                  {settingsNavigation.map((item) => (
                    <li key={item.name}>
                      <Link
                        to={"/settings/" + item.href}
                        className={clsx(
                          item.href == tab
                            ? "text-squawk-blue"
                            : "text-gray-500 dark:text-gray-400",
                          "hover:text-squawk-blue-light transition"
                        )}
                      >
                        {item.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </nav>
            </header>

            {renderTab}
          </main>
        </div>
      </div>
    </>
  );
}

// export default Settings;
